import React, { memo } from 'react';
import { Checkbox as RSuiteCheckbox } from 'rsuite';
import styled from 'styled-components';

const StyledCheckbox = styled(RSuiteCheckbox)`
  border-radius: 4px;

  .rs-checkbox-wrapper {
    background-color: #ffffff;
    border-radius: 4px;
    :after {
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
    }
  }

  .rs-checkbox-checker {
    padding: 0px;
    margin-left: -10px;
  }

  :hover,
  :focus {
    border-color: #37a3bc;
  }
`;

function CheckboxWrapper(props) {
  return <StyledCheckbox {...props} />;
}

export const Checkbox = memo(CheckboxWrapper);
